// Wire Desk — shared design tokens.
// One source of truth for the palette/type system so components never
// re-declare their own colors. Mirrors the approved mockup 1:1.

export const color = {
  ink: '#0a0c11',
  panel: '#12141c',
  panel2: '#171a24',
  rule: '#2b3244',
  ruleSoft: '#1c2130',
  bone: '#eef1f6',
  boneDim: '#9aa2b4',
  boneFaint: '#5c6377',
  glass: 'rgba(18, 22, 32, .62)',

  cyan: '#4fd8e8',
  cyanDim: '#2b8f9c',
  cyanGlow: 'rgba(79, 216, 232, .35)',

  amber: '#f0a63e',
  amberDim: '#96691f',
  amberGlow: 'rgba(240, 166, 62, .3)',

  teal: '#3de0a8',
  tealDim: '#1f8a67',
  tealGlow: 'rgba(61, 224, 168, .35)',

  red: '#ff5c72',
  redDim: '#9c3245',
  redGlow: 'rgba(255, 92, 114, .3)',
};

export const font = {
  display: "'Unbounded', 'Segoe UI', sans-serif",
  body: "'Inter', -apple-system, 'Segoe UI', sans-serif",
  mono: "'JetBrains Mono', 'SFMono-Regular', Consolas, monospace",
};

// Cut-corner "bevel" used on every major panel — the app's one
// structural signature, standing in for the rounded-corner default.
export const bevel = (size = 12) =>
  `polygon(${size}px 0, 100% 0, 100% calc(100% - ${size}px), calc(100% - ${size}px) 100%, 0 100%, 0 ${size}px)`;

export const statusStyle = {
  live: { color: color.teal, border: color.tealDim, glow: color.tealGlow },
  draft: { color: color.amber, border: color.amberDim, glow: color.amberGlow },
  scheduled: { color: color.cyan, border: color.cyanDim, glow: color.cyanGlow },
};
